

function IcoVideoLlamada({width="64",height="64"}) {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" stroke-width="2" d="m22 13l8-5v16l-8-5ZM2 8v16h20V8Z"/>
</svg>
  );
}

export default IcoVideoLlamada;
